import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { joinClasses } from 'utils/utility';
import { useImagesContext } from 'contexts/ImagesContext';
import { clickAnime, calvh } from 'utils/element';
import { ButtonBase } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  'button-logout': {
    height: ({ height }) => height || calvh('7vh'),
    maxWidth: '22vw',
    objectFit: 'contain',
  },
}));

const ButtonLogout = (props) => {
  const { onClick, disabled } = props;
  const { images } = useImagesContext();
  const c = joinClasses(useStyles({ ...props }));

  return (
    <ButtonBase className={c('root')}>
      <img
        className={c('button-logout')}
        src={images['button-logout-btn.png']}
        ref={(ref) => !disabled && clickAnime(ref)}
        onClick={(e) => !disabled && onClick(e)}
      />
    </ButtonBase>
  );
};

export default ButtonLogout;
